<template>
    <div class="content kb-content">
        <tests-management-page
            :init-trans="initTrans"
            :init-routes="initRoutes"
            :locale="locale"
            v-if="isTestManagementPageShown"
            :document="currentDocument"
        />
        <div
            v-show="!isTestManagementPageShown"
            class="kb-content-wrapper"
        >
            <slot></slot>
        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex";
import TestsManagementPage from "./tests/TestsManagementPage";

export default {
    name: "BaseContent",
    props: {
        initTrans: Object,
        initRoutes: Object,
        locale: {
            type: String,
            default: 'ru'
        },
    },
    components: {TestsManagementPage},
    computed: {
        ...mapGetters('tests', ['isTestManagementPageShown']),
        ...mapGetters('baseDocumentData', ['currentDocument']),
    },
}
</script>

<style scoped>
 .kb-content-wrapper {
     display: flex;
     width: 100%;
 }
</style>
